module.exports = {
          srcSet: __webpack_public_path__ + "public/4c6ee51886664849b5ed534f9c8db977-1080.jpg"+" 1080w",
          images:[ {path: __webpack_public_path__ + "public/4c6ee51886664849b5ed534f9c8db977-1080.jpg",width: 1080,height: 1080}],
          src: __webpack_public_path__ + "public/4c6ee51886664849b5ed534f9c8db977-1080.jpg",
          toString:function(){return __webpack_public_path__ + "public/4c6ee51886664849b5ed534f9c8db977-1080.jpg"},
          
          width: 1080,
          height: 1080
        }